export const hasValidConversationComponentRoute = (route: string): boolean => {
  const invalidRoutes = ['/identity-management', '/profile'];
  return !invalidRoutes.includes(route);
};
